import { getBillingReconciliationOperatorContext } from '../../hooks/api/billingReconciliationBacContextApi.js';
import {
  evidenceFromBacContext,
  operatorContextKey,
} from '../../hooks/api/useBillingReconciliationEvidenceHooks.js';

const normalizePrefetchTarget = (value) => {
  if (value && typeof value === 'object') {
    const bac = String(value.bac || '').trim();
    if (!bac) return null;
    return {
      bac,
      varianceId: value.varianceId || value.id || null,
    };
  }
  const bac = String(value || '').trim();
  return bac ? { bac, varianceId: null } : null;
};

const prefetchTargetKey = ({ bac, varianceId } = {}) => `${bac || ''}:${varianceId || ''}`;

const uniqueTargets = (values = [], activeBac = null, limit = 3) => {
  const active = String(activeBac || '');
  const seen = new Set();
  const result = [];
  for (const value of values) {
    const target = normalizePrefetchTarget(value);
    if (!target || target.bac === active) continue;
    const key = prefetchTargetKey(target);
    if (seen.has(key)) continue;
    seen.add(key);
    result.push(target);
    if (result.length >= limit) break;
  }
  return result;
};

export const prefetchBacContextWindow = async ({
  queryClient,
  runId,
  enabled = true,
  importMode = null,
  activeBac = null,
  prefetchBacs = [],
  limit = 500,
  windowSize = 3,
  contextMode = 'critical',
  isCancelled = () => false,
  signal = undefined,
} = {}) => {
  if (!enabled) return;
  if (!queryClient || !runId || importMode === 'historical_backfill') return;
  const targets = uniqueTargets(prefetchBacs, activeBac, windowSize);
  if (!targets.length || isCancelled() || signal?.aborted) return;
  for (const { bac, varianceId } of targets) {
    if (isCancelled() || signal?.aborted) return;
    const bundle = await getBillingReconciliationOperatorContext({
      runId,
      bac,
      varianceId,
      limit,
      importMode,
      contextMode,
      signal,
    });
    if (isCancelled() || signal?.aborted) return;
    if (!bac) continue;
    queryClient.setQueryData(
      operatorContextKey({ runId, bac, varianceId, importMode, contextMode }),
      {
        ...evidenceFromBacContext(bundle?.bacContext?.data),
        operatorBundle: bundle,
        workflow: {
          ...(bundle?.bacContext?.data?.workflow || {}),
          actions: bundle?.varianceActions?.data || bundle?.bacContext?.data?.workflow?.actions || [],
        },
      },
    );
  }
};
